
import axios, { AxiosHeaders } from "axios";

interface RefreshResponse {
  accessToken: string;
  refreshToken: string;
}

const axiosInstance = axios.create({
  baseURL: "",
  headers: { "Content-Type": "application/json" },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  const skipToken = [
    "/api/v1/auth/login",
    "/api/v1/common/api/health",
    "/api/v1/auth/refresh",
  ].some((path) => (config.url ?? "").includes(path));

  if (token && !skipToken) {
    // headers 보장
    if (!config.headers) config.headers = new AxiosHeaders();

    // Axios v1 호환 세팅
    const h: any = config.headers;
    if (typeof h.set === "function") {
      h.set("X-AUTH-TOKEN", token);
    } else {
      h["X-AUTH-TOKEN"] = token;
    }
  }
  return config;
});

/*

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.config) return Promise.reject(error);

    const originalRequest = error.config as any;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem("refreshToken");
        if (!refreshToken) throw new Error("No refresh token");

        const { data }: { data: RefreshResponse } = await axios.post(
          "/api/v1/auth/refresh",
          null,
          { headers: { "X-REFRESH-TOKEN": refreshToken } }
        );

        localStorage.setItem("accessToken", data.accessToken);
        localStorage.setItem("refreshToken", data.refreshToken);

        // 재시도 요청에도 반드시 토큰을 set()으로 주입
        if (!originalRequest.headers) originalRequest.headers = new AxiosHeaders();
        const h: any = originalRequest.headers;
        if (typeof h.set === "function") {
          h.set("X-AUTH-TOKEN", data.accessToken);
        } else {
          h["X-AUTH-TOKEN"] = data.accessToken;
        }

        return axiosInstance(originalRequest);
      } catch (e) {
        localStorage.clear();
        window.location.href = "/login";
        return Promise.reject(e);
      }
    }

    return Promise.reject(error);
  }
);
*/

export default axiosInstance;
